// extracted by mini-css-extract-plugin
export default {"r_l":"_93858d1cf3 e90c78c8cb","t":"b5e5993806"};